import { gql } from '@apollo/client';

/**
 * Fragment canónico de Campaign — alineado con GenericOrder + campo `name`
 * exclusivo (Campaign es tipo especial de OT genérica con nombre).
 *
 * Los campos Tipo B (indexExpedition, indexType, state) son opcionales por
 * compatibilidad con documentos legacy anteriores al refactor — `saveCampaign`
 * los setea siempre.
 *
 * Ver PLAN-SAVE-ENTITY-UNIFIED.md §2.4. Campaign es top-level (sin parent).
 */
export const NEW_CAMPAIGN = gql`
  fragment NewCampaign on Campaign {
    id

    # ─── Índices + estado (nullable por compatibilidad) ───
    indexExpedition
    indexType
    state

    # ─── Tipo C exclusivo Campaign ───
    name

    # ─── Tipo B denormalizado (coherente con Order paralela) ───
    concessionIDs
    roadIDs
    teamIDs
    pkInitKm
    pkInitMeter
    pkEndKm
    pkEndMeter
    track
    direction
    margin
    lane
    creationDate
    registerInitDate
    derivedEndDate

    # ─── Entidad doble ───
    orderIDs
  }
`;
